import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { DonationPageLayout } from './layouts/page';

export const DonationPage = () => {
	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<DonationPageLayout />
		</SiteLayoutComponent>
	);
};